export const API_URL = process.env.REACT_APP_API_URL as string;
export const SANDBOX_API_URL = process.env.REACT_APP_SANDBOX_API_URL as string;
export const SANDBOX_SWAGGER_URL = process.env.REACT_APP_SANDBOX_SWAGGER_URL as string;
export const NIYO_SWAGGER_URL = process.env.REACT_APP_NIYO_SWAGGER_URL as string;
export const TRAVELTHRU_SWAGGER_URL = process.env.REACT_APP_TARVELTHRU_SWAGGER_URL as string;
export const UPLOAD_API_KEY = process.env.REACT_APP_UPLOAD_API_KEY as string;
export const S3_BUCKET_URL = process.env.REACT_APP_S3_BASE_URL as string;

